import { Card, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { APP_ICONS } from "../../assets";

const DashboardCard = ({ cardData, cardIndex }) => {
  return (
    <Card
      sx={{
        p: 2,
        boxShadow: 1,
        borderBottom: "1px solid black",
        borderColor: "primary.light",
      }}
    >
      <Stack direction={"row"} alignItems={"center"} gap={2}>
        <IconButton
          color="primary"
          sx={{
            backgroundColor: "primary.bgLight",
            borderRadius: "50%",
            color: "#eb8b05",
          }}
        >
          {React.isValidElement(cardData.icon) ? cardData.icon : null}
        </IconButton>
        <Typography
          fontSize={"1.25rem"}
          fontWeight={700}
          color={"primary.light"}
        >
          {cardData.value}
        </Typography>
      </Stack>
      <Typography
        mt={2}
        variant="body1"
        fontWeight={600}
        color={"customColor.tundora"}
      >
        {cardData.title}
      </Typography>
      {/* <Stack direction={"row"} alignItems={"center"} gap={1} mt={0.3}> */}
      {/* <img src={APP_ICONS.arrowUpwordIconGreen} width={12} />
        <Typography
          variant="body1"
          fontWeight={500}
          color={"customColor.tundora"}
        >
          +\- {cardData.percentage}%
        </Typography> */}
      {/* <Typography variant="body2" color={"customColor.dustyGray"}>
          than last week
        </Typography> */}
      {/* </Stack> */}
    </Card>
  );
};

export default DashboardCard;
